const pendingRequests = new Map();

/**
 * Aynı anda gönderilen aynı istekleri engeller.
 * İkinci istek, ilk isteğin promise'ini paylaşır.
 * İstek tamamlandığında key temizlenir, yeni istek yapılabilir.
 */
export function deduplicatePost(originalPost) {
  return function (url, data, config) {
    const key = `${url}:${JSON.stringify(data || {})}`;

    if (pendingRequests.has(key)) {
      return pendingRequests.get(key);
    }

    const promise = originalPost(url, data, config).finally(() => {
      pendingRequests.delete(key);
    });

    pendingRequests.set(key, promise);
    return promise;
  };
}

export function deduplicateAxios(axiosInstance) {
  const axiosPending = new Map();

  const deduped = function (config) {
    const key = `${config.method}:${config.url}:${JSON.stringify(config.data || {})}`;

    if (axiosPending.has(key)) {
      return axiosPending.get(key);
    }

    const promise = axiosInstance(config).finally(() => {
      axiosPending.delete(key);
    });

    axiosPending.set(key, promise);
    return promise;
  };

  Object.keys(axiosInstance).forEach((k) => {
    if (!(k in deduped)) {
      deduped[k] = axiosInstance[k];
    }
  });

  return deduped;
}
